import styled from "styled-components";
import { Basket } from "../../types/Basket/Basket";
import { OrderLineItem } from "../../types/Order/OrderLineItem";
import { TableActionButtonDelete } from "../../@ui/TableActionButtonDelete";
import TableActionButton from "../../@ui/TableActionButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Price from "../../@ui/Price";

interface BasketItemProps {
  item: OrderLineItem;
  removeItem: (id: string) => void;
}

const BasketItemContainer = styled.div`
  border-top: 1px solid #ccc;

  h4 {
    font-size: 1.1rem;
    font-weight: 400;
  }

  p {
    font-size: 0.9rem;
    white-space: pre;
  }

  padding: 0.5rem 0 0.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
`;

const PriceField = styled.div.attrs({ className: "text-black" })`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
`;

const BasketItem = ({ item, removeItem }: BasketItemProps) => {
  return (
    <BasketItemContainer className="w-100">
      <div>
        {" "}
        <h4 className="text-black">{item?.layerName}</h4>
        <p className="basket-line-item">{item?.description}</p>
        <TableActionButton onClick={() => removeItem(item.id)}>
          <FontAwesomeIcon icon={faTrash} />
        </TableActionButton>
      </div>

      <PriceField>
        <div>
          <Price
            currencyCode={item.transactionCurrencyCode}
            price={item?.priceExTax}
          />
        </div>
      </PriceField>
    </BasketItemContainer>
  );
};

export default BasketItem;
